<fieldset>
  <legend [ngClass]="{ 'visually-hidden': !fieldDescription }" class="mb-0 mt-2">
    <p *ngIf="fieldDescription" class="paragraph--size-standard">
      {{ fieldDescription }}{{ getRequired() ? '*' : '' }}
    </p>
    <span *ngIf="!fieldDescription">
      {{ labelOverride || fgInfo?.label }}
    </span>
  </legend>
  <ng-container *ngIf="!readonly">
    <div class="wrapper">
      <label [hidden]="hideLabel">
        {{ labelOverride || fgInfo?.label
        }}{{ formControl['condrequired'] || fgInfo?.required ? '*' : '' }}
      </label>
      <br *ngIf="!hideLabel" />
      <mat-radio-group
        [required]="fgInfo.required"
        [formControl]="formControl"
        (change)="onChange($event)"
        [attr.aria-label]="labelOverride || fgInfo?.label"
      >
        <span>
          <mat-radio-button
            class="radioOption"
            *ngFor="let option of filteredGroups[0]?.options"
            [attr.data-automation-id]="dataAutomationId"
            [value]="option.value"
            [disabled]="option.isDisabled"
            color="primary"
            [ngClass]="{ stackRadio: !showRadioHorizontal }"
          >
            {{ option.name }}
          </mat-radio-button>
        </span>
      </mat-radio-group>
      <ng-conatiner *ngFor="let errorDefinition of errorDefinitions">
        <mat-error class="checkbox-error mat-error" *ngIf="formControl.touched && errorDefinition.showFunction() && !hiddenErrorKeys.includes(errorDefinition.key)">
          {{ errorDefinition.errorMessage(formControl) }}
        </mat-error>
      </ng-conatiner>
    </div>
  </ng-container>
  <ng-container *ngIf="readonly">
    <mat-form-field
      class="no-underline w-100"
      [floatLabel]="'always'"
      [ngClass]="{ 'read-only': readonly, 'no-label': hideLabel }"
    >
      <mat-label [hidden]="hideLabel">{{ labelOverride || fgInfo?.label }}</mat-label>
      <input
        readonly
        matInput
        [attr.data-automation-id]="dataAutomationId"
        [value]="currentSelection"
        tabindex="-1"
      />
    </mat-form-field>
  </ng-container>
</fieldset>
